import { defineComponent as i, openBlock as t, createElementBlock as o, mergeProps as m, unref as e, renderSlot as u, createElementVNode as a, createCommentVNode as g } from "vue";
import { useScalarIcon as Z } from "../hooks/useScalarIcon.js";
const A = { key: 0 }, f = { key: 1 }, L = { key: 2 }, M = { key: 3 }, h = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconCodeSimple"
}, C = /* @__PURE__ */ i({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(r) {
    const s = r, { bind: d, weight: n } = Z(s);
    return (p, l) => (t(), o("svg", m({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(d)), [
      u(p.$slots, "default"),
      e(n) === "bold" ? (t(), o("g", A, l[0] || (l[0] = [
        a("path", { d: "M96,73,34.06,128,96,183A12,12,0,1,1,80,201L8,137A12,12,0,0,1,8,119L80,55A12,12,0,0,1,96,73ZM248,119,176,55A12,12,0,1,0,160,73l61.91,55L160,183A12,12,0,1,0,176,201l72-64A12,12,0,0,0,248,119Z" }, null, -1)
      ]))) : e(n) === "duotone" ? (t(), o("g", f, l[1] || (l[1] = [
        a("path", {
          d: "M240,128l-72,64H88L16,128,88,64h80Z",
          opacity: "0.2"
        }, null, -1),
        a("path", { d: "M93.31,70,28,128l65.27,58a8,8,0,1,1-10.62,12l-72-64a8,8,0,0,1,0-12l72-64A8,8,0,1,1,93.31,70Zm152,52-72-64a8,8,0,0,0-10.62,12L228,128l-65.27,58a8,8,0,1,0,10.62,12l72-64a8,8,0,0,0,0-12Z" }, null, -1)
      ]))) : e(n) === "fill" ? (t(), o("g", L, l[2] || (l[2] = [
        a("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM101.66,162.34a8,8,0,0,1-11.32,11.32l-40-40a8,8,0,0,1,0-11.32l40-40a8,8,0,0,1,11.32,11.32L67.31,128Zm104-28.68-40,40a8,8,0,0,1-11.32-11.32L188.69,128,154.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,205.66,133.66Z" }, null, -1)
      ]))) : e(n) === "light" ? (t(), o("g", M, l[3] || (l[3] = [
        a("path", { d: "M92,68.49,25,128l67,59.52a6,6,0,1,1-8,9l-72-64a6,6,0,0,1,0-9l72-64a6,6,0,0,1,8,9Zm152,55-72-64a6,6,0,0,0-8,9L231,128l-67,59.52a6,6,0,1,0,8,9l72-64a6,6,0,0,0,0-9Z" }, null, -1)
      ]))) : e(n) === "regular" ? (t(), o("g", h, l[4] || (l[4] = [
        a("path", { d: "M93.31,70,28,128l65.27,58a8,8,0,1,1-10.62,12l-72-64a8,8,0,0,1,0-12l72-64A8,8,0,1,1,93.31,70Zm152,52-72-64a8,8,0,0,0-10.62,12L228,128l-65.27,58a8,8,0,1,0,10.62,12l72-64a8,8,0,0,0,0-12Z" }, null, -1)
      ]))) : e(n) === "thin" ? (t(), o("g", k, l[5] || (l[5] = [
        a("path", { d: "M90.66,67,22,128l68.64,61a4,4,0,0,1-5.32,6l-72-64a4,4,0,0,1,0-6l72-64a4,4,0,1,1,5.32,6Zm152,58-72-64a4,4,0,1,0-5.32,6L234,128l-68.64,61a4,4,0,0,0,5.32,6l72-64a4,4,0,0,0,0-6Z" }, null, -1)
      ]))) : g("", !0)
    ], 16));
  }
});
export {
  C as default
};
